import * as React from 'react';
import PropTypes from 'prop-types';
import ChannelTabItem from './channelTabItem';

const propTypes = {
  list: PropTypes.arrayOf(PropTypes.object),
  select: PropTypes.number,
  onClick: PropTypes.func,
};

const defaultProps = {
  list: [],
  select: -1,
  onClick: null,
};

function handlerTabSelect(index, onClick) {
  return () => {
    if (typeof onClick === 'function') {
      onClick(index);
    }
  };
}

const ChannelTabs = props => {
  const { list, select, onClick } = props;
  return (
    <div className="channel-tab-container">
      {list.map((ch, index) => (
        <ChannelTabItem
          key={ch.group_id}
          select={index === select}
          onClick={handlerTabSelect(index, onClick)}
        >
          {ch.group_title}
        </ChannelTabItem>
      ))}
    </div>
  );
};

ChannelTabs.propTypes = propTypes;
ChannelTabs.defaultProps = defaultProps;

export default ChannelTabs;
